/**
 * Drawn in the membership badge's style rather than as TradingView's logo. Hidden from screen readers:
 * TradingView is always written beside it.
 */
export function TradingViewMark({ size = 20 }: { size?: number }) {
  return (
    <span
      aria-hidden
      className="d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0"
      style={{
        width: size,
        height: size,
        borderRadius: size / 4,
        background: "var(--cui-body-color)",
        color: "var(--cui-body-bg)",
        fontSize: size * 0.45,
        lineHeight: 1,
      }}
    >
      TV
    </span>
  );
}
